import axios from "axios";
import { BASE_URL } from "../Global";

//Login
export const loginAPI = async (email, password) => {
    const response = await fetch(`${BASE_URL}/api/user/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
    });
    return response;
};

//SignUp
export const registerAPI = async (email, password) => {
    const response = await fetch(`${BASE_URL}/api/user/signup`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
    });
    return response;
};

//Forget Password
export const forgetPasswordAPI = async (email) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/api/user/forget-password`,
            { email },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

//Reset Password
export const resetPasswordAPI = async (password, token) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/api/user/reset-password`,
            { password },
            { params: { token } }
        );
        return { success: true, message: response.data.message };
    } catch (error) {
        return { success: false, message: error.response.data.error };
    }
};

//Google Login
export const googleLoginAPI = async (authorizationCode) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/api/user/google`,
            { code: authorizationCode }, // Send code in request body
            {
                headers: {
                    "Content-Type": "application/json",
                    // Remove Authorization header since we're sending code in body
                },
            }
        );
        return response;
    } catch (error) {
        // Improve error handling
        if (error.response) {
            // Server responded with non-2xx status
            throw new Error(error.response.data.message || "Authentication failed");
        } else {
            throw new Error("Network error - failed to connect to server");
        }
    }
};

//Google One Tap
export const googleOneTapAPI = async (credential) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/api/user/google-one-tap`, // Different endpoint for One Tap
            { credential }, // Send JWT credential directly
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        if (error.response) {
            throw new Error(
                error.response.data?.message || "One Tap authentication failed"
            );
        } else if (error.request) {
            throw new Error("No response received from server");
        } else {
            throw new Error("Network error - failed to initiate request");
        }
    }
};
